/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Menu item with multilingual labels and nested children support
 */
export type settings_MenuItem = {
    children?: Array<settings_MenuItem>;
    icon?: string;
    labels: Record<string, string>;
    order?: number;
    pageSlug?: string;
    target?: string;
    type: settings_MenuItem.type;
    url?: string;
    visible?: boolean;
};
export namespace settings_MenuItem {
    export enum type {
        ROUTE = 'route',
        PAGE = 'page',
        EXTERNAL = 'external',
    }
}

